import { ImageResource } from './ImageResource';
import { hasPropertiesOfType } from 'util/Utils';

export class Content
{
    contentId: string = '';
    title: string = '';
	description: string = '';
	image: ImageResource = new ImageResource();
	eula?: string = '';
	imageData?: string;
	physioToolsId: string = '';

    private static readonly stringProps = ['contentId', 'title', 'description'];

    static fromJson(json: any): Content | undefined
    {
        if (typeof json === 'object' &&
            hasPropertiesOfType(json, 'string', Content.stringProps))
        {
            const content = new Content();

            content.contentId = json.contentId;
            content.title = json.title;
			content.description = json.description;
			content.eula = json.eula;
			content.image = ImageResource.fromJson(json.imageResource);
			content.physioToolsId = json.physioToolsId;

            return content;
        }
        else
        {
            return undefined;
        }
	}
}

export enum ContentCodeStartType
{
    "Activation",
    "Date"
}

export class ContentCode
{
	public contentId: string = '';
	public contentCode: string = '';
	public activations: number = 0;
	public maxActivations: number = 0;
	public startTime: string = '';
	public startType: ContentCodeStartType = ContentCodeStartType.Activation;
	public validFrom: string = '';
	public validThru: string = '';
	public active: boolean = true;
	public physioToolsId: string = '';
	
	static fromJson(json: any): ContentCode | undefined
	{
		if (typeof json === 'object')
		{
			const code = new ContentCode();

			code.contentId = json.contentId;
			code.contentCode = json.contentCode;
			code.activations = json.activations;
			code.maxActivations = json.maxActivations;
			code.startTime = json.startTime;
			code.validFrom = json.validFrom;
			code.validThru = json.validThru;
			code.active = json.active;
			code.physioToolsId = json.physioToolsId;

			try
			{
				let value = json.startType as keyof typeof ContentCodeStartType;
				code.startType = ContentCodeStartType[value];
			}
			catch (e)
			{
				console.log("Failed to parse ContentCodeStartType");
			}

			return code;
		}
		else
		{
			return undefined;
		}

	}
}

export class ContentCodeActivation
{
	public id: string = '';
	public userAlias: string = '';
	public active: boolean = false;
	public startTime: string = '';

	static fromJson(json: any): ContentCodeActivation | undefined
	{
		if (typeof json === 'object')
		{
			const activation = new ContentCodeActivation();
			activation.id = json.id;
			activation.userAlias = json.userAlias;
			activation.active = json.active;
			activation.startTime = json.startTime;
			return activation;
		}
		else
		{
			return undefined;
		}
	}
}

export class ContentCodeEditData
{
	public contentCode: string | undefined;
	public startType: ContentCodeStartType | undefined;
	public startTime: string | undefined;
	public validFrom: string | undefined;
	public validThru: string | undefined;
	public active: boolean | undefined;
	public maxActivations: number | undefined;
}